import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { SubcategoriesList } from './components/SubcategoriesList'

const SubcategoriesPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Subcategories</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <SubcategoriesList />
        </div>
      </div>
    </>
  )
}

export { SubcategoriesPage }

